module.exports = __webpack_public_path__ + "static/granner1-8657d6bfbaae69e20f052e8f6452a651.jpg";